module.exports = __webpack_public_path__ + "static/media/oval_b.d9536946.svg";